/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import CustomPlainCardTile from '../../../../common/components/CustomPlainCardTile/CustomPlainCardTile';
import { Box } from '@mui/system';
import ReturnedAssetListBox from '../../../../common/components/ReturnedAssetListBox';
import { Grid, Typography } from '@mui/material';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import { fonts, themes } from '../../../../common/themes/themes';
import _ from 'lodash';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { baseDateFormatting } from '../../../../common/helper';
import { DateField } from '../../../../components';
interface propsType {
  returnedassetData: any;
  isLoading?: boolean;
  trans?: any;
}
const ReturnedAssetsPresenter: React.FC<propsType> = ({
  returnedassetData,
  isLoading,
  trans,
}) => {
  return (
    <div>
      <CustomPlainCardTile
        card_title={trans('Returned Assets')}
        title_color="#F44336"
        card_height="330px"
        card_subtitle={`${trans('Total')}: ${returnedassetData.length}`}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {returnedassetData.length > 0 ? (
              _.map(returnedassetData, (returnasset: any, i) => {
                return (
                  <div key={i}>
                    <Box style={{ marginBottom: '24px' }} />
                    <ReturnedAssetListBox
                      trans={trans}
                      key={returnasset?.asset_id}
                      tile_value={returnasset?.brand_name}
                      subtitle1={trans('Asset Id')}
                      assetId={returnasset?.asset_id}
                      subtitle2={trans('Asset Type')}
                      assetType={returnasset?.name}
                      subtitle3={trans('Assigned')}
                      assignedDate={
                        returnasset?.date ? (
                          <DateField
                            value={returnasset?.date}
                            format={baseDateFormatting}
                          />
                        ) : (
                          '-'
                        )
                      }
                      returnedtitle={trans('Returned')}
                      returnedDate={
                        returnasset?.return_date ? (
                          <DateField
                            value={returnasset?.return_date}
                            format={baseDateFormatting}
                          />
                        ) : (
                          '-'
                        )
                      }
                      subtitle4={trans('Reason')}
                      remarks={returnasset?.return_reason}
                    />
                  </div>
                );
              })
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Added')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Returned Assets')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>
        )}
      </CustomPlainCardTile>
    </div>
  );
};
export default ReturnedAssetsPresenter;
